export default __webpack_public_path__ + "static/media/SWT0290.34I-20309_-14776_0.e586262c.jpg";